import { gql } from '@apollo/client'
import { pathOr } from 'ramda'
import React from 'react'

import { integrationsClient } from '../../../utils/apollo/api'
import { usePromiseQuery } from '../../../utils/apollo/_helpers/promiseQuery'
import Select from '../../../packages/kiti/components/form/Select'
import { useProjectId } from '@btime/react-session'

const QUERY = gql`
  query SegwareTechnicians($projectId: Int) {
    SegwareTechnicians(projectId: $projectId) {
      id
      name
    }
  }
`

const useTechniciansLoader = (filter, currentProjectId) => {
  const query = usePromiseQuery(QUERY, {
    variables: { projectId: currentProjectId },
    client: integrationsClient,
    fetchPolicy: 'cache-first'
  })
  return () => {
    return query(filter)?.then(pathOr([], ['data', 'SegwareTechnicians']))
  }
}

const SegwareTechnicianSelect = ({ onChange, value, filter, ...props }) => {
  const currentProjectId = useProjectId()
  const getOptions = useTechniciansLoader(filter, currentProjectId)

  return (
    <Select
      value={value} //
      onChange={onChange}
      options={getOptions}
      disablePagination
      {...props}
    />
  )
}

export default SegwareTechnicianSelect
